export const isScrollToEnd = (element: Element | null) => {
  if (element) {
    return element?.scrollLeft + element?.clientWidth >= element?.scrollWidth
  }

  return false
}
